const composeEnhancers = (...enhancers) => (uploader, ...args) => enhancers.reduce((enhanced, e) => e(enhanced, ...args) || enhanced, uploader);
export default composeEnhancers;